const styles = {
  title: {
    fontWeight: "700",
    fontSize: "32px",
    lineHeight: "1.2",
    letterSpacing: "-0.5px",
    marginBottom: "16px",
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"

  },
  downloadLink: {
    textDecoration: "underline",
    textUnderlineOffset: "3px",
    cursor: "pointer",
    border: "none",
    background: "none",
    padding: 0,
    transition: "color 0.2s ease",
    "&:hover": {
      color: "#0066cc"
    }
  },
  warningBanner: {
    borderRadius: "16px",
    gap: "12px"
  }
};

export default styles;